







































import Vue from 'vue';
import Component from 'vue-class-component';
import { ItemCoreSpec } from '../types';

@Component
export default class CreateItem extends Vue {
  public name: string | null = null;
  public link: string | null = null;
  public description: string | null = null;
  public isExpanded: boolean = false;
  public errorMessage: string | null = null;

  public onCreateItem() {
    if (!this.name) {
      this.errorMessage = 'Please enter a name for the item';
      return;
    }

    const itemCoreSpec: ItemCoreSpec = {
      name: this.name
    };

    if (this.description) {
      itemCoreSpec.description = this.description;
    }

    if (this.link) {
      itemCoreSpec.link = this.link;
    }

    this.$emit('item-created', itemCoreSpec);
  }
}
